<template>
  <div class="row" v-on:click="IvBeenClicked()">
    <i class="column1 icon-mail" :class="notification.type"></i>
    <div class="column2">{{notification.message.length>40?notification.message.substring(0, 40)+'...' : notification.message}}</div>
    <div class="column3">{{notification.Date.getHours()+':'+notification.Date.getMinutes()}}</div>
  </div>

</template>

<script>
  import Notification from './../../../../Class/Notification'
    export default {
        name: "NotificationItem",
        props: {
          notification: {
            type : Object,
            required:true,
          },
          index: {
            type : Number,
            required:true,
          }
        },
        methods:{
            IvBeenClicked(){
            alert('Doing Somthing with ['+this.notification.Content+' '+this.notification.Date+']');
            this.$store.dispatch('seen',this.index)

          }
        }
    }
</script>

<style scoped>
  div{
    color: white;
  }
  .column1 {
    float: left;
    width: 15%;
    font-size: 200%;
    margin-top: 15px;
  }
  .column2 {
    float: left;
    width: 70%;
  }
  .column3 {
    float: left;
    width: 15%;
  }
  .row:after {
    content: "";
    display: table;
    clear: both;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/views/layout/components/notification/notificationItem.vue